import Modal from 'bootstrap/js/dist/modal'

const projectPageModal = document.getElementById('projectPageModal')

if (projectPageModal) {
  const form = document.querySelector('.needs-validation')
  const projectBsModal = Modal.getOrCreateInstance('#projectPageModal')

  form.addEventListener('submit', event => {

    const textarea = form.querySelector('#editor-col textarea')
    const msgcontainer = form.querySelector('#editor-col')
    const errorcontainer = msgcontainer.querySelector('.invalid-feedback')
    const mainbodyRequiredMsg = msgcontainer.getAttribute('data-mandatory')
    const mainbodyTooLongMsg = msgcontainer.getAttribute('data-too-long')

    if (tinymce.activeEditor.plugins.wordcount.getCount('words') > 1000) {
      textarea.setCustomValidity(mainbodyTooLongMsg)
      errorcontainer.innerHTML = mainbodyTooLongMsg
    } else {
      textarea.setCustomValidity("")
      errorcontainer.innerHTML = mainbodyRequiredMsg
    }

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }

    form.classList.add('was-validated')
  }, false)

  projectPageModal.addEventListener('show.bs.modal', event => {
    const editorStyles = projectPageModal.querySelector('#editor-col').getAttribute('data-css')

    tinymce.init({
      selector: '#Data_MainBody',
      iframe_attrs: {
        'aria-required': 'true',
        'aria-describedby': 'tmce-description'
      },
      menubar: false,
      plugins: 'wordcount',
      toolbar: 'undo redo | blocks | bold italic | alignleft aligncentre alignright alignjustify | indent outdent | bullist numlist | wordcount',
      formats: {
        // Changes the default format for h1 to have a class of heading h1 and tag h2
        h1: { block: 'h2', classes: 'h1' }
      },
      content_css: editorStyles,
      setup: function (editor) {
        editor.on('blur', function () {
          editor.save()
        })
      }
    })
  })

  projectPageModal.querySelector('#form-cancel')?.addEventListener('click', () => {
    form.reset()
  })

  if (projectPageModal.hasAttribute('data-has-error')) {
    projectBsModal.show()
  }
}